// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Lock from "@insite/mobius/Icons/Lock";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { wishListSharingStatusStyles } from "@rpsc/Overrides/Components/WishListSharingStatus";
import IconPrivateInfo from "@rpsc/XDL/Icons/IconPrivateInfo";
import IconSharedBy from "@rpsc/XDL/Icons/IconSharedBy";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

const sharedLabelStyles: TypographyPresentationProps = {
    size: 12,
    lineHeight: "17px",
    weight: fontConfig.weight.bold,
    color: "common.black",
};

wishListSharingStatusStyles.statusText = {
    css: css`
        display: flex;
        align-items: center;

        ${TypographyStyle} {
            display: flex;
        }
    `,
};

wishListSharingStatusStyles.sharedByLink = {
    mergeCss: true,
    css: css`
        &:not([disabled]):hover {
            & > ${TypographyStyle} > div > ${TypographyStyle}:first-child {
                color: ${color("common.ui8")};
            }
        }
    `,
};

wishListSharingStatusStyles.autogeneratedLabel = {
    ...sharedLabelStyles,
};

wishListSharingStatusStyles.autogeneratedIcon = {
    size: 13,
    src: Lock,
    color: "primary.main",
    css: css`
        margin-right: 6px;
    `,
};

wishListSharingStatusStyles.shareWithOthers = {
    mergeCss: true,
    css: css`
        ${TypographyStyle} {
            display: flex;
            line-height: 17px;
            color: ${color("common.black")};
        }
    `,
};

wishListSharingStatusStyles.sharedByNameWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

wishListSharingStatusStyles.sharedByLabel = {
    ...sharedLabelStyles,
    css: css`
        &:not([disabled]):visited {
            color: ${color("common.ui12")};
        }
        &:not([disabled]):hover {
            color: ${color("common.ui8")};
        }
    `,
};

wishListSharingStatusStyles.sharedByName = {
    color: "common.ui6",
    lineHeight: "17px",
    weight: fontConfig.weight.regular,
};

wishListSharingStatusStyles.sharedIcon = {
    src: IconSharedBy,
    size: 11,
    color: "primary.main",
    css: css`
        &,
        svg {
            height: 13px;
        }
        margin-right: 6px;
    `,
};

wishListSharingStatusStyles.privateLabel = {
    ...sharedLabelStyles,
};

wishListSharingStatusStyles.privateTooltip = {
    iconProps: {
        src: IconPrivateInfo,
        size: 12,
        css: css`
            opacity: 1;
            &,
            svg {
                height: 13px;
            }
        `,
    },
    cssOverrides: {
        tooltipContainer: css`
            & {
                transform: translateX(0%);
            }
        `,
        tooltipClickable: css`
            margin-right: 6px;
        `,
        tooltipArrow: css`
            left: auto;
        `,
    },
};
